/* eslint-disable max-len */
import React, { Fragment, useRef, useState} from 'react';
import 'tw-elements';
import TableBody from './TableBody';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import {  useSelector } from 'react-redux';

const Table = ({pageNumber, handleOnClickSort,addOpen,confirmationState, getBranch, sortValue, setConfirmationState,email, branchName, searchParams}) => {
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const StaffList = useSelector(state => state.StaffSlice);
    const { List} = StaffList;
    const urlParams = new URLSearchParams(window.location.search);
    const branchUrl = urlParams.get('sort');

    /**
     * The function handles sorting based on a given key and current sort value.
     */
    const handleSort = (key) => {
        if(sortValue === '') handleOnClickSort('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleOnClickSort('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleOnClickSort('sort', `${key}+asc`)
        }
    }

    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;

    return (
        <div className='-mx-1]'>
            <div className={`flex mb-1 overflow-auto ${List?.data?.length < 10 ? 'pb-[100px]' : 'pb-[6px]'} scroll-bar px-1`} id = "search-result">
                <table aria-label="Outside Table" className="w-full" id='admin-table'>
                    <thead>  
                        <tr>
                            <th class="w-[14%]">
                                <span class="flex text-start justify-start">Employee Number
                                </span>
                            </th>
                            <th class="w-[12%]">
                                <span id='full_name'
                                    onClick={() => {handleSort('full_name')}}
                                >Full Name
                                    <button type='button' className="pl-1.5" >
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "full_name" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th class="w-[13%]">
                                <span class="flex items-center text-f2 justify-start font-semibold text-[#031624]">Email Address
                                </span>
                            </th>
                            <th class="w-[14%]">
                                <span >Mobile Number
                                </span>
                            </th>
                            <th class="w-[11%]">
                                <span class="flex items-center text-f2 justify-start font-semibold text-[#031624]">Type
                                </span>
                            </th>
                            <th class="w-[12%]">
                                <span  id='created_at'
                                    onClick={() => {handleSort('created_at')}}
                                >Created on
                                    <button type='button' className="pl-1.5" >
                                        <img loading="lazy" decoding="async" src={branchUrl === null || branchUrl?.split("+")[0] === "created_at" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th class="w-[11%]">
                                <span class="flex items-center justify-center" id='status'
                                    onClick={() => {handleSort('status')}}
                                >Status
                                    <button type='button' className="pl-1.5" >
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "status" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th class="w-[7%]">
                                <span class="flex items-center justify-center">Actions
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {List?.data.map((item , index = 0) => (
                            <Fragment key={item._id}>
                                <TableBody
                                    branchName={branchName}
                                    tableData={item}
                                    getBranch={getBranch}
                                    setConfirmationState={setConfirmationState}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List.data?.length}
                                    email={email}
                                />
                            </Fragment>
                        ))}
                    
                    </tbody>
                    {List?.data?.length === 0 && (
                        <tbody>
                            <tr>
                                <td style={{ 'line-height': '100px'}} colspan="7" className="no-records-message" id='no-matching-result'>
                                    {noSearchOrFilter ? `No employees added yet.` : 'No matching records found.'}
                                </td>
                            </tr>
                        </tbody>                        
                    )}
                </table>
            </div>
        </div>
        
    );
}

export default Table;
